<!--
  - Website: https://www.4myth.com
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Copyright © 2016-2022 All rights reserved.
  - MyTh Ahmed Fayez
  -->

<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <h4 class="headline">
          {{ $t('logoutPage.loading') }}
        </h4>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'Logout',
  mounted () {
    this.logoutUser(!0)
  }
}
</script>
